/** Shared i18next init options. `load: 'languageOnly'` avoids /locales/en-US and en-GB 404s. */
export const i18nInitOptions = {
  fallbackLng: 'en',
  debug: true,
  load: 'languageOnly',
};
